// Puts opaque overlay over parent component if isDisabled is true
import PropTypes from 'prop-types';
import React from 'react';

const Disabled = ({ isDisabled, zIndex }) => {
  const zIndexValue = !isNaN(zIndex) ? zIndex : 2;
  const className = isDisabled ? 'disabled' : '';

  return (
    <>
      <div className={className} />
      <style jsx>{`
        .disabled:after {
          content: '';
          background: rgba(255, 255, 255, 0.65);
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: ${zIndexValue};
        }
      `}</style>
    </>
  );
};

Disabled.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  zIndex: PropTypes.number,
};

export default Disabled;
